// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';
import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

//Libraries
import { SkipTo } from '../../shared/library/skipto';

//Token
import { authToken } from '../../shared/authToken';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------

// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Component
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
  selector:'cpdes-app',
  template : '<router-outlet id="router_outlet_app_level"></router-outlet>',
  providers:[
    CASNavBoxService,
    casNgbDateParserFormatter,
    CPDFormatters,
    Helpers,
    NgbDatepickerConfig,
    WebServices,
    
    //Alternate parser for bootstrap calendar (will use: mm/dd/yyyy)
    { provide:NgbDateParserFormatter, useClass:casNgbDateParserFormatter }
  ]
})
export class AppComponent implements OnInit {


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
	_authToken = null;
    _skipTo = null;

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor( config: NgbDatepickerConfig, router:Router ){
        
        this.constructor.mapParams( this, arguments );
        this._authToken = authToken;

        //Config bootstrap calendar
        let dt = new Date();
        config.minDate = {year: dt.getFullYear(), month: dt.getMonth()+1, day: dt.getDate()};
        config.maxDate = {year: (new Date()).getFullYear() + 50, month: 12, day: 31};

        //Enable this to debug route change events
        //router.events.subscribe((val) => { debugger; console.log(val); });
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){
        //alert("App.js");
    };

    ngAfterViewInit() {
        this._skipTo = new SkipTo();
        this._skipTo.init({
            onPopupOpen: function() {
                let navBarMenuButton = document.getElementById('hamburger');
                if (!navBarMenuButton) {
                    return;
                }
                let navMenu = document.getElementById('navigationBox');
                if (!navMenu) {
                    return;
                }
                let navMenuStyle = window.getComputedStyle(navMenu);
                if (!navMenuStyle) {
                    return;
                }
                let navMenuHidden = navMenuStyle.display === 'none';
                if (navMenuHidden) {
                    navBarMenuButton.click();
                }
            },
            onPopupClose: function (clickedTargetText) {
                let navBarHeadings = [
                    "navigation",
                    "actions"
                ];
                var targetInNavBarHeadings = navBarHeadings.find((heading) => heading === clickedTargetText);
                if (targetInNavBarHeadings) {
                    return;
                }
                let navBarMenuButton = document.getElementById('hamburger');
                if (!navBarMenuButton) {
                    return;
                }
                let navMenu = document.getElementById('navigationBox');
                if (!navMenu) {
                    return;
                }
                let navMenuStyle = window.getComputedStyle(navMenu);
                if (!navMenuStyle) {
                    return;
                }
                let navMenuPopUpDisplayedInMobile = navMenuStyle.display === 'block' && navMenu.attributes.class.textContent.includes("cpd-nav-popup-mode");
                if (navMenuPopUpDisplayedInMobile) {
                    navBarMenuButton.click();
                }
            }
        });
    }
    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    // I replaced this with the current app.module routes approach.  Keeping it here
    // for a while though in case I want to revert.
    ////==================================
    //// devRedirect
    ////==================================
    //// Call this method to automatically be redirected to the test harness when not logged in.
    //devRedirect(){
    //    if( authToken.token == null ){
    //        //Check if we have access to roles which would mean we are debug mode.
    //        if( window.location.pathname !== "/test-harness" && window.location.pathname !== "/public" ){
    //            this.rolesService.Get().then( x => {
    //                if( x === null ){
    //                    //Redirect to bad access//
    //                }
    //                else{
    //                    //Redirect to test harness because we are in debug mode//
    //                    this.router.navigate(["/test-harness"]);
    //                }
    //            } );
    //        }
    //    }
    //};


}
